import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';

export type TicketView = 'list' | 'board';

interface Props {
	value: TicketView;
	onChange: (next: TicketView) => void;
}

const Group = styled.div`
	display: inline-flex;
	align-items: center;
	overflow: hidden;
	border-radius: 6px;
	border: 1px solid #e2e8f0;
`;

export function ViewToggle({value, onChange}: Props) {
	return (
		<Group role="group" aria-label="View">
			<Button emphasis={EMPHASIS.MEDIUM} onPress={() => onChange('list')} aria-pressed={value === 'list'}>
				<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
					<rect x="1" y="2" width="12" height="1.5" rx="0.5" fill="currentColor" />
					<rect x="1" y="6" width="12" height="1.5" rx="0.5" fill="currentColor" />
					<rect x="1" y="10" width="12" height="1.5" rx="0.5" fill="currentColor" />
				</svg>
				List
			</Button>
			<Button emphasis={EMPHASIS.MEDIUM} onPress={() => onChange('board')} aria-pressed={value === 'board'}>
				<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
					<rect x="1" y="1" width="5" height="12" rx="1" fill="currentColor" />
					<rect x="8" y="1" width="5" height="12" rx="1" fill="currentColor" />
				</svg>
				Board
			</Button>
		</Group>
	);
}
